import { getFormData, trackFormData, sendFormData } from './data';
// import { executeRecaptcha } from './recaptcha';
import { showLightbox, hideLightbox } from '../lightbox';
import { hideSticky } from '../sticky';
import autocomplete from '../autocomplete';
import suburbs from '../suburbs';
import estates from '../estates';
import { trackGoal } from '../tracking';
import { gtmUpdateOrRegisteredInterest, gtmEnquiries, gtmContactUs} from '../../components/products/index';

const events = {
  login: {
    submit: ({ target: form }) => {
      const success = ({ saved_products: saved , method: method}) => {
        if (typeof saved === 'undefined') {
          $('.form__description--no-account-error').css('display', 'block');
          $('.form__description--register').css('display', 'none');
        }
        else {
          $(`<div class="user-menu__saved">${saved}</div>`).prependTo('.user-menu');
          // GTM (Customer Accounts - Log in)
          dataLayer.push({
            event: "login",
            method: method // "{{ method used to authenticate }} " // facebook or email // TODO get method from form?
          });
          showLightbox('You are now logged in', 'loggedin');
        }
      };
      const error = ({ reason }) => {
        console.log(`Login error: ${reason}`); // eslint-disable-line no-console
      };
      sendFormData(form, success, error);
      return false;
    }
  },
  register: {
    submit: ({ target: form }) => {
          const success = ({ status: status, reason: reason, saved_products: saved, method: method }) => {
              if (status == "error") {
                  console.log(`Login error: ${reason}`); // eslint-disable-line no-console
              } else {
                  $('<div class="user-menu__saved">0</div>').prependTo('.user-menu');
                  // GTM (Customer Accounts - Sign up)
                  dataLayer.push({
                      event: "sign_up",
                      method: method // "{{ method used to authenticate }} " // facebook or email  // TODO get method from form?
                  });
                  showLightbox('Thank you for registering', 'loggedin');
              }
      };
      const error = ({ reason }) => { // this is if the entire request fails
        console.log(`Login error: ${reason}`); // eslint-disable-line no-console
          };

      sendFormData(form, success, error);
      return false;
    },
    init: ({ target: form }) => {
        suburbs($('input[name="postcode"]', form));
    }
  },
  registration: {
      submit: ({ target: form }) => {
        let redirectLink = form.querySelector('input[name="RedirectLink"]');
        let submitButton = form.querySelector('button[type="submit"]');
        //const track = trackFormData(form); // this is the old GA event replaced by form_submission_success
        const success = ({ message }) => {
          const formElement = document.getElementById('registrationForm');
          let paddingSize = formElement.offsetHeight / 2;

          if (message === 'success') {
            const registrationThanks = document.getElementById('registration-thanks');
            registrationThanks.style.display = 'block';
            registrationThanks.style.fontSize = 'x-large';
            registrationThanks.style.lineHeight = 'normal';
            paddingSize -= registrationThanks.offsetHeight;
            registrationThanks.style.padding = paddingSize.toString().concat('px 10px ', paddingSize.toString(), 'px 10px'); // padding top right bottom left
            if (redirectLink != null && redirectLink.value.length > 0) {
              window.location = redirectLink.value;
            }
          }
          else {
            const resultMessage = document.getElementById('returnMessage');
            resultMessage.append(message);
            resultMessage.style.fontSize = 'x-large';
            resultMessage.style.lineHeight = 'normal';
            paddingSize -= resultMessage.offsetHeight;
            resultMessage.style.padding = paddingSize.toString().concat('px 10px ', paddingSize.toString(), 'px 10px'); // padding top right bottom left
          }

          formElement.style.display = 'none';
        };

          sendFormData(form, success, null, null, null);
          submitButton.setAttribute('disabled', '');
          submitButton.innerHTML = 'Loading...';
        return false;
      },
    init: ({ target: form }) => {
      suburbs($('input[name="postcode"]', form)); // to enable suburb look up on this form
    }
  },
  updates: {
    submit: ({ target: form }) => {
      // const track = trackFormData(form); // this is the old GA event replaced by form_submission_success
      trackGoal(null, 'submitRegisterUpdates'); // use goalName
      sendFormData(form, null, null, null, null); // removed track from pre slot
      var projectGAInfo = document.getElementById("ProjectGAInfo");
      var productGAInfo = document.getElementById("productGAinfo");

      gtmUpdateOrRegisteredInterest(projectGAInfo, productGAInfo, form);
      showLightbox('Thanks for signing up', 'updates-survey');
      return false;
    },
    init: ({ target: form }) => {
        suburbs($('input[name="postcode"]', form));
    }
  },
  'updates-thanks': {
    submit: () => {
      showLightbox('Thank you for signing up', 'updates-survey');
      return false;
    }
  },
  'updates-survey': {
    submit: ({ target: form }) => {
      const surveyStep = +form.querySelector('.form__step-input:checked').value;
      sendFormData(form);
      showLightbox('Thank you!', 'updates-survey-thankyou');
      return false;
    }
  },
  'updates-survey-thankyou': {
    submit: () => {
      hideLightbox();
      return false;
    }
  },
  subscribe: {
    submit: ({ target: form }) => {
      showLightbox('', 'updates', getFormData(form));
      hideSticky();
      form.reset();
      return false;
    }
  },
  'campaign-form': {
      submit: ({ target: form }) => {
        var formId = form.querySelector('input[name="formId"]');
        showLightbox('', 'campaign-' + formId.value, getFormData(form));
        hideSticky();
        form.reset();
        return false;
      }
  },
  campaign: {
      submit: ({ target: form }) => {
          var redirectLink = form.querySelector('input[name="RedirectLink"]');
          var submitButton = form.querySelector('button[type="submit"]');

          if (redirectLink != null && redirectLink.value != "") {
              // const track = trackFormData(form); // this is the old GA event replaced by form_submission_success
              var success = function (redirectLink) {
                  if (redirectLink != null) {
                      window.location = redirectLink;
                  }
              };
              sendFormData(form, success, null, null, null); // removed track from pre slot

              submitButton.setAttribute('disabled', true);
              submitButton.innerHTML = 'Loading...';
              
              return false;
          }
          else
          {
              // const track = trackFormData(form); // this is the old GA event replaced by form_submission_success
              sendFormData(form, null, null, null, null); // removed track from pre slot

              var formId = form.querySelector('input[name="formId"]');
              showLightbox('', 'campaign-thankyou-' + formId.value);

              return false;
          }       
      },
      init: ({ target: form }) => {
          suburbs($('input[name="postcode"]', form));
      }
  },
  'onPageCampaign': {
      submit: ({ target: form }) => {
          var redirectLink = form.querySelector('input[name="RedirectLink"]');
          var submitButton = form.querySelector('button[type="submit"]');
          var showSurvey = form.querySelector('input[name="showSurvey"]');
          var noThanks = form.querySelector('input[name="noThanks"]');
          // const track = trackFormData(form); // this is the old GA event replaced by form_submission_success
          var success = function (redirectLink) {
              if (redirectLink != null) {
                 window.location = redirectLink;
              }
          };
          sendFormData(form, success, null, null, null); // removed track from pre slot
          var projectGAInfo = document.getElementById("ProjectGAInfo");
          var productGAInfo = document.getElementById("productGAinfo");

          gtmUpdateOrRegisteredInterest(projectGAInfo, productGAInfo, form);

          if (redirectLink != null && redirectLink.value != "") {
              submitButton.setAttribute('disabled', true);
              submitButton.innerHTML = 'Loading...';
          }
          else if (noThanks.value === "true") {
              // if there's no custom intro just load the survey light box with no alterations
              showLightbox('Help us, help you!', 'updates-survey');
          }
          else {
              // they don't want to show the thank you page separate before the survey they want to merge them so
              // the plan is to take the id="onPageCampaignThankyouCustomMessage" and plop it in the id="surveyCustomMessage"
              // but there is only one light box visible at a time and I can't seem to access it any other way
              showLightbox('', 'onPageCampaign-thankyou');
              var titleSrc = document.getElementsByClassName("lightbox__title");
              var titleSrcValue = "";
              if (titleSrc !== null && titleSrc[0] !== null) {
                  if (titleSrc[0].style.display === 'none') {
                      titleSrcValue = 'Tell us more about yourself';
                  } else {
                      titleSrcValue = titleSrc[0].innerHTML;
                  }
              }
              var messageSrc = document.getElementById("onPageCampaignThankyouCustomMessage");
              
              showLightbox('Help us, help you!', 'updates-survey');
              var messageTgt = document.getElementById("surveyCustomMessage");
              var titleTgt = document.getElementsByClassName("lightbox__title");

              if (messageSrc !== null && messageTgt !== null) {
                  messageTgt.innerHTML = messageSrc.innerHTML;
              }
              // assuming the title is being copied across as well
              if (titleSrcValue !== "" && titleTgt !== null) {
                  titleTgt[0].innerHTML = titleSrcValue;
              }
          }

          return false;
      },
      init: ({ target: form }) => {
          suburbs($('input[name="postcode"]', form));
      }
  },
  'campaign-thanks': {
      submit: ({ target: form }) => {
        showLightbox('Help us, help you!', 'updates-survey');
        return false;
      }
    },
 'onPageCampaign-thankyou': {
     submit: ({ target: form }) => {
         showLightbox('Help us, help you!', 'updates-survey');
         return false;
     }
	},
email: { 
  submit: ({ target: form }) => {
    // const track = trackFormData(form); // this is the old GA event replaced by form_submission_success
    const next = form.querySelector('input[name="next"]');
    let goal = 'submitEnquireNow';
    const prodInfo = form.elements.enquireProductInfo;
    if (prodInfo === undefined) {
      goal = 'submitEmailUs';
    }
    trackGoal(null, goal);
    sendFormData(form, null, null, null, null); // removed track from pre slot
    
    var projectGAInfo = document.getElementById("ProjectGAInfo");
    var productGAInfo = document.getElementById("productGAinfo");
    if (goal === 'submitEnquireNow') {
      gtmEnquiries(projectGAInfo, productGAInfo, form);
    }
    else {
      gtmContactUs(form);
    }

    showLightbox('Thank you for your enquiry!', next ? next.value : 'updates-survey');
    return false;
  },
  init: ({ target: form }) => {
    suburbs($('input[name="postcode"]', form));
    autocomplete(form);
    // executeRecaptcha(form);
  }
},
  'corporate-hero-search': {
    init: ({ target: form }) => {
      estates(form);
    },
    submit: e => {
      e.preventDefault();
      const valueInput = e.target.querySelector('input[name="ItemId"]');
      if (valueInput) {
        const url = valueInput.value;
        if (url) {
          const openExternal = url.match(/^http/i);
          if (openExternal) {
            window.open(url);
          }
          else {
            window.location = url;
          }
        }
      }
    }
  },
  'remove-saved-product': {
    submit: ({ target: form }) => {
      sendFormData(form);
      const $carousel = $(form).closest('.saved-products');
      const $allSavedProducts = $carousel.find('.saved-product');
      const $savedProduct = $(form).closest('.saved-product');
      const savedProductIndex = Array.from($allSavedProducts).indexOf($savedProduct[0]);
      $carousel.trigger('remove.owl.carousel', savedProductIndex);
      $carousel.trigger('refresh.owl.carousel');
      return false;
    }
  }
};

export default formName => events[formName] || {};
